import { VStack } from "@chakra-ui/react";
import { TreatmentPieChart } from "./TreatmentPieChart";
import { CraAttributePieChart } from "./CraAttributePieChart";
import { ScorePieChart } from "./CraScorePieChart";
import { CraAttributes } from "@keita/lanepatrol-sdk";
import {
  MapColoring,
  MapColoringType,
} from "../../../../map/models/MapColoring";
import { HlaAttributePieChart } from "./HlaAttributePieChart";

export const MapColoringPieChart = ({ coloring }: { coloring: MapColoring }) => {
  const renderContent = () => {
    switch (coloring.type) {
      case MapColoringType.Treatment:
        return <TreatmentPieChart treatmentType={coloring.treatmentType} />;
      case MapColoringType.CraAttribute:
        return (
          <CraAttributePieChart
            attributeDefinition={
              CraAttributes.getByName(coloring.attributeName)!
            }
          />
        );
      case MapColoringType.Score:
        return <ScorePieChart crashType={coloring.scoreKey} />;
      case MapColoringType.HlaAttribute:
        return <HlaAttributePieChart attributeName={coloring.attributeName} />;
    }
  };

  return <VStack fontSize="sm">{renderContent()}</VStack>;
};
